export * from "-!../../../../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./game-banner.vue?vue&type=template&id=f21a3862"


//////////////////
// WEBPACK FOOTER
// ./skins/bulmasite/components/common/banners/game-banners/game-banner.vue?vue&type=template&id=f21a3862
// module id = 8nAd
// module chunks = 0